import { render, staticRenderFns } from "./wechat.vue?vue&type=template&id=9f5e63f6&"
import script from "./wechat.vue?vue&type=script&lang=js&"
export * from "./wechat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\git仓库\\iot_vehicle\\iot_frontend\\iot_supplier\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f5e63f6')) {
      api.createRecord('9f5e63f6', component.options)
    } else {
      api.reload('9f5e63f6', component.options)
    }
    module.hot.accept("./wechat.vue?vue&type=template&id=9f5e63f6&", function () {
      api.rerender('9f5e63f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/payment/wechat.vue"
export default component.exports